import { render, staticRenderFns } from "./DMP_NARVAL.vue?vue&type=template&id=85c06586"
import script from "./DMP_NARVAL.vue?vue&type=script&lang=js"
export * from "./DMP_NARVAL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports